import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { SvgIconLoad } from './svg-icon.actions';
import { Observable } from 'rxjs';
import { SvgIconState } from './svg-icon.state';
import { SvgIconService } from './svg-icon.service';
import { SafeHtml } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class SvgIconFacade {
  loaded$: Observable<boolean> = this.store.select(SvgIconState.getLoaded);

  constructor(private store: Store, private svgIconService: SvgIconService) {}

  loadSvgIcon(svgPath: string): void {
    this.store.dispatch(new SvgIconLoad(svgPath));
  }

  getSvgIconMap(): Map<string, Observable<SafeHtml>> {
    return this.svgIconService.svgIconMap;
  }

  getIcon(svgPath: string): Observable<SafeHtml> {
    return this.svgIconService.getSvgIcon(svgPath);
  }
}
